/**
 * call integration
 */
import customerStore from '@/store/modules/customer/index.js';
import uuidV4 from 'liquor-tree/src/utils/uuidV4';
import { cstaDefs } from '@/util/call/neomecca/netDialAPI';
import { store } from '@/store/store';
import logReport from '@/util/logReport';
import eventBus from '@/EventBus';
import apiEvent from '@/util/call/apiEvent';
// import { getERPEnableList } from '@/constants/custom/openLink/erpInfo';

// 네오메카 계열에서 사용: 네오메카, 네오메카 webRTC
const neoAgentStatuses = [
  { id: 1, statusType: '대기', parentMode: cstaDefs.AgentMode.AM_READY, subMode: '', type: 'IN_COUNSELING' },
  { id: 10, statusType: '타업무', parentMode: 2, subMode: '01' },
  { id: 2, statusType: '식사중', parentMode: 2, subMode: '02' },
  { id: 3, statusType: '휴식중', parentMode: 2, subMode: '03' },
  { id: 7, statusType: '자리비움', parentMode: 2, subMode: '04' },
  { id: 8, statusType: '교육중', parentMode: 2, subMode: '05' },
  { id: 9, statusType: '면담중', parentMode: 2, subMode: '06' },
  { id: 4, statusType: '회의중', parentMode: 2, subMode: '08' },
  { id: 6, statusType: '상담준비', parentMode: 2, subMode: '09' }
];

// KT 계열에서 사용: KT, KLCNS
const ktAgentStatuses = [
  { id: 1, statusType: '대기', parentMode: 1, subMode: '' },
  { id: 10, statusType: '타업무', parentMode: 2, subMode: '01' },
  { id: 2, statusType: '식사중', parentMode: 2, subMode: '02' },
  { id: 3, statusType: '휴식중', parentMode: 2, subMode: '03' },
  { id: 7, statusType: '자리비움', parentMode: 2, subMode: '04' },
  { id: 8, statusType: '교육중', parentMode: 2, subMode: '05' },
  { id: 9, statusType: '면담중', parentMode: 2, subMode: '06' },
  { id: 4, statusType: '회의중', parentMode: 2, subMode: '08' },
  { id: 6, statusType: '상담준비', parentMode: 2, subMode: '09' }
];

const getDefaultState = () => {
  return {
    isDragging: false,
    isInitUi: false, // 콜상담데스크 좌측, 중앙, 우측 UI 노출 여부 판단값
    isDimmed: false, // 콜 상담데스크 딤드 UI 노출 여부 판단값
    dimmedTitle: '사용중인 서비스가 아닙니다.',
    dimmedContent: '',
    etcCallStatusList: [
      { id: 10, callSubState: '01', nameCd: '타업무', code: 'OTHER_BUSINESS' },
      { id: 2, callSubState: '02', nameCd: '식사중', code: 'EAT_OUT' },
      { id: 3, callSubState: '03', nameCd: '휴식중', code: 'TAKE_BREAK' },
      { id: 7, callSubState: '04', nameCd: '자리비움', code: 'OUT_OF_OFFICE' },
      { id: 8, callSubState: '05', nameCd: '교육중', code: 'IN_EDUCATION  ' },
      { id: 9, callSubState: '06', nameCd: '면담중', code: 'INTERVIEW' },
      { id: 4, callSubState: '08', nameCd: '회의중', code: 'IN_MEETING' }
    ],
    callAgentStatus: '',
    callWorkingStatusList: [],
    callAgentStatusStartTime: '',
    btnStatus: {
      login: false, // 로그인
      logOut: false, // 로그아웃
      makeCall: false, // 걸기
      answer: false, // 받기
      hold: false, // 보류
      retrieve: false, // 재통화
      consult: false, // 협의
      transfer: false, // 전환
      conference: false, // 회의
      reconnect: false, // 전환 취소
      notReady: false, // 대기 외 다른 상태
      ready: false, // 대기
      disconnect: false, // 끊기
      reserve: false, // 예약
      sendMessage: false // 문자발송
    },
    callInfo: {
      brandDnis: '',
      callbackId: '',
      callbackType: '',
      callEvent: '',
      channelUniqueKey: '',
      contactTypeId: '',
      userKey: '',
      recordNo: '',
      dnis: '',
      startTime: '',
      endTime: '',
      serviceCode: '',
      incomingChannel: '',
      taskData: {},
      tagList: [],
      memo: '',
      isClose: false,
      isAgentClose: false,
      isSummaryCompleted: true,
      ticketId: null,
      ticketDisplayId: null, // 콜봇 ticketIncident 조회용
      isReservation: false,
      ticketStatus: '',
      isOriginatedEnd: false,
      isCleared: false,
      isAnonymous: false,
      isCallEnd: false,
      isWorking: false,
      isHold: false, // 보류 여부
      callBrand: {
        brandId: null,
        name: '',
        moduleChannelId: null,
        calledNumber: '',
        representativeNumber: ''
      },
      uuid: '', // STT기능을 위한 식별키
      isErpStoragePassible: false, // ERP 연동 저장 여부
      usageLocation: '' // 고객 정보를 조회한 곳 ex) 콜 인입(상담중일 때), 고객 이력 조회(통화중 아닐 때 고객 정보 조회)
    },
    channelUniqueKey: false,
    isTransferCancel: false,
    isSpying: false, // 상담사가 현재 감청기능을 사용 중인지 여부
    viewingCallbackDateTime: '' // 현재 상담사가 조회중인 콜백 예약일시 (고객정보란 노출 용도)
  };
};

const state = getDefaultState();

const getters = {
  getIsInitUi: (state) => {
    return state.isInitUi;
  },
  getIsDimmed: (state) => {
    return state.isDimmed;
  },
  getDimmedTitle: (state) => {
    return state.dimmedTitle;
  },
  getDimmedContent: (state) => {
    return state.dimmedContent;
  },
  callAgentStatus: (state) => {
    return state.callAgentStatus;
  },
  btnStatus: (state) => {
    return state.btnStatus;
  },
  callInfo: (state) => {
    return state.callInfo;
  },
  isSummaryCompleted: (state) => {
    return state.callInfo.isSummaryCompleted;
  },
  callUserKey: (state) => {
    return state.callInfo.userKey;
  },
  callAgentStatusStartTime: (state) => {
    return state.callAgentStatusStartTime;
  },
  isAnonymous: (state) => {
    return state.isAnonymous;
  },
  channelUniqueKey: (state) => {
    return state.channelUniqueKey;
  },
  isTransferCancel: (state) => {
    return state.isTransferCancel;
  },
  getEtcCallStatusList: (state) => {
    return state.etcCallStatusList;
  },
  getCurrentCallBrand: (state) => {
    return state.callInfo.callBrand;
  },
  isDragging: (state) => {
    return state.isDragging;
  },
  callKey: (state) => {
    return store.getters.isKtOrKlcns ? state.callInfo.uuid : state.callInfo.recordNo;
  },
  getIsSpying: (state) => {
    return state.isSpying;
  },
  getIsErpSavePossible: (state) => {
    return state.callInfo.isErpStoragePassible;
  },
  getTicketDisplayIdFromCallInfo: (state) => {
    return state.callInfo.ticketDisplayId;
  },
  getUsageLocation: (state) => {
    return state.callInfo.usageLocation;
  },
  getViewingCallbackDateTime: (state) => {
    return state.viewingCallbackDateTime;
  }
};

const actions = {
  initCallAgentStatus(context) {
    context.commit('initCallAgentStatus');
  },
  initBtnStatus(context) {
    context.commit('initBtnStatus');
  },
  initCallInfo(context) {
    context.commit('initCallInfo');
  },
  initLocalStorage(context) {
    context.commit('initCallAgentStatus');
    context.commit('initBtnStatus');
    context.commit('initCallInfo');
    localStorage.setItem('call-info', JSON.stringify(state.callInfo));
    localStorage.setItem('btn-status', JSON.stringify(state.btnStatus));

    const data = JSON.parse(localStorage.getItem('call-agent-status'));
    if (!(data && data.status && data.status === state.callAgentStatus)) {
      localStorage.setItem(
        'call-agent-status',
        JSON.stringify({
          status: state.callAgentStatus,
          time: new Date().getTime()
        })
      );
    }
  },
  changeCallUserKey(context, payload) {
    customerStore.mutations.changeCustomerPhoneNumber(customerStore.state, payload);
    context.commit('changeCallUserKey', payload);
  },
  getCallWorkingStatusList({ state }) {
    state.callWorkingStatusList = store.getters.isKtOrKlcns ? ktAgentStatuses : neoAgentStatuses;
  }
};

const mutations = {
  changeIsInitUi(state, payload) {
    state.isInitUi = payload;
  },
  changeIsDimmed(state, payload) {
    state.isDimmed = payload;
  },
  initCallAgentStatus(state) {
    const data = JSON.parse(localStorage.getItem('call-agent-status'));
    if (data) {
      state.callAgentStatus = data.status;
      state.callAgentStatusStartTime = data.time;
    } else {
      state.callAgentStatus = '';
      state.callAgentStatusStartTime = '';
    }
  },
  initBtnStatus(state) {
    const data = JSON.parse(localStorage.getItem('btn-status'));
    state.btnStatus = data || {
      login: false, // 로그인
      logOut: false, // 로그아웃
      makeCall: false, // 걸기
      answer: false, // 받기
      hold: false, // 보류
      retrieve: false, // 재통화
      consult: false, // 협의
      transfer: false, // 전환
      conference: false, // 회의
      reconnect: false, // 전환 취소
      notReady: false, // 대기 외 다른 상태d
      ready: false, // 대기
      disconnect: false, // 끊기
      reserve: false, // 예약
      sendMessage: false // 문자발송
    };
  },
  initCallInfo(state) {
    const data = JSON.parse(localStorage.getItem('call-info'));
    state.callInfo = data || {
      brandDnis: '',
      callbackId: '',
      callbackType: '',
      callEvent: '',
      channelUniqueKey: '',
      contactTypeId: '',
      direction: '',
      dnis: '',
      endTime: '',
      incomingChannel: '',
      isAgentClose: false,
      isAnonymous: false,
      isCallEnd: false,
      isCleared: false,
      isClose: false,
      isOriginatedEnd: false,
      isSummaryCompleted: true,
      isWorking: false,
      memo: '',
      recordNo: '',
      serviceCode: '',
      startTime: '',
      tagList: [],
      taskData: {},
      ticketId: null,
      ticketDisplayId: null,
      isReservation: false,
      ticketStatus: '',
      isHold: false,
      userKey: '',
      callBrand: {
        brandId: null,
        name: '',
        moduleChannelId: null,
        calledNumber: '',
        representativeNumber: ''
      },
      uuid: '',
      isErpStoragePassible: false,
      usageLocation: ''
    };
  },
  clearCallInfo(state) {
    state.callInfo = {
      brandDnis: '',
      callEvent: '',
      channelUniqueKey: '',
      userKey: '',
      recordNo: '',
      direction: '',
      dnis: '',
      startTime: '',
      endTime: '',
      serviceCode: '',
      incomingChannel: '',
      taskData: {},
      contactTypeId: '',
      tagList: [],
      memo: '',
      isClose: false,
      isAgentClose: false,
      isSummaryCompleted: true,
      ticketId: null,
      ticketDisplayId: null,
      isReservation: false,
      ticketStatus: '',
      callbackId: '',
      callbackType: '',
      isOriginatedEnd: false,
      isCleared: false,
      isAnonymous: false,
      isCallEnd: false,
      isWorking: false,
      isHold: false,
      callBrand: {
        brandId: null,
        name: '',
        moduleChannelId: null,
        calledNumber: '',
        representativeNumber: ''
      },
      uuid: '',
      isErpStoragePassible: false,
      usageLocation: ''
    };
  },
  clearCallWorkingStatusList(state) {
    state.callWorkingStatusList = [];
  },
  changeCallAgentStatus(state, payload) {
    const data = localStorage.getItem('call-agent-status');
    if (!(data && JSON.parse(data).status === payload)) {
      const callAgentStatusData = {
        status: payload,
        time: new Date().getTime()
      };
      state.callAgentStatus = callAgentStatusData.status;
      state.callAgentStatusStartTime = callAgentStatusData.time;
      localStorage.setItem('call-agent-status', JSON.stringify(callAgentStatusData));
    }
  },
  changeBtnStatus(state, payload) {
    state.btnStatus = payload;
    localStorage.setItem('btn-status', JSON.stringify(state.btnStatus));
  },
  changeCallInfo(state) {
    localStorage.setItem('call-info', JSON.stringify(state.callInfo));
  },
  changeDnis(state, payload) {
    state.callInfo.dnis = payload;
  },
  changeBrandDnis(state, payload) {
    state.callInfo.brandDnis = payload;
  },
  changeStartTime(state, payload) {
    state.callInfo.startTime = payload;
  },
  changeEndTime(state, payload) {
    state.callInfo.endTime = payload;
  },
  changeIncomingChannel(state, payload) {
    state.callInfo.incomingChannel = payload;
  },
  changeServiceCode(state, payload) {
    state.callInfo.serviceCode = payload;
  },
  changeIsClose(state, payload) {
    state.callInfo.isClose = payload;
  },
  changeIsAgentClose(state, payload) {
    state.callInfo.isAgentClose = payload;
  },
  changeIsSummaryCompleted(state, payload) {
    state.callInfo.isSummaryCompleted = payload;
  },
  changeCallEvent(state, payload) {
    state.callInfo.callEvent = payload;
  },
  changeDirection(state, payload) {
    state.callInfo.direction = payload;
  },
  changeCallUserKey(state, payload) {
    if (payload.includes('anonymous') || payload === 'notdefined') {
      payload = uuidV4().replaceAll('-', '').substr(0, 12);
      state.callInfo.isAnonymous = true;
    } else if (state.callInfo.isAnonymous) {
      state.callInfo.isAnonymous = false;
    }
    state.callInfo.userKey = payload;
  },
  changeTicketId(state, payload) {
    state.callInfo.ticketId = payload;
  },
  changeTicketDisplayId(state, payload) {
    state.callInfo.ticketDisplayId = payload;
  },
  changeIsReservation(state, payload) {
    state.callInfo.isReservation = payload;
  },
  changeRecordNo(state, payload) {
    state.callInfo.recordNo = payload;
  },
  changeCallBackInfo(state, payload) {
    state.callInfo.callbackId = payload.callbackId;
    state.callInfo.callbackType = payload.callbackType;
  },
  changeIsOriginatedEnd(state, payload) {
    state.callInfo.isOriginatedEnd = payload;
  },
  changeIsCleared(state, payload) {
    state.callInfo.isCleared = payload;
  },
  changeTaskData(state, payload) {
    state.callInfo.taskData = payload;
  },
  changeContactTypeId(state, payload) {
    state.callInfo.contactTypeId = payload;
  },
  changeCallTagList(state, list) {
    state.callInfo.tagList = list;
  },
  changeMemo(state, payload) {
    state.callInfo.memo = payload;
  },
  changeTicketStatus(state, payload) {
    state.callInfo.ticketStatus = payload;
  },
  changeIsCallEnd(state, isCallEnd) {
    state.callInfo.isCallEnd = isCallEnd;
  },
  changeIsWorking(state, isWorking) {
    state.callInfo.isWorking = isWorking;
  },
  changeIsHold(state, isHold) {
    state.callInfo.isHold = isHold;
  },
  changeUuid(state, uuid) {
    state.callInfo.uuid = uuid;
  },
  changeCallInfoByKey(key, value) {
    state.callInfo[key] = value;
  },
  clearIsAnonymous(state) {
    state.callInfo.isAnonymous = false;
  },
  CLEAR_CALL_STATUS(state) {
    localStorage.removeItem('call-info');
    localStorage.removeItem('btn-status');
    localStorage.removeItem('call-agent-status');
    window.sessionStorage.clear();
    mutations.clearCallInfo(state);
    mutations.clearCallWorkingStatusList(state);
  },
  setChannelUniqueKey(state, payload) {
    state.channelUniqueKey = payload;
    state.callInfo.channelUniqueKey = payload;
  },
  setIsTransferCancel(state, payload) {
    state.isTransferCancel = payload;
  },
  changeCallWorkingStatus(state, payload) {
    if (state.callAgentStatus === '통화중') {
      logReport.write(`[EMIT]CONNECTION - originated-completed`);
      eventBus.$emit('call-connection', 'originated-completed');
      return;
    }
    const selectedStatus = state.callWorkingStatusList.find((status) => status.id === payload);
    if (store.getters.isAvailableCall) {
      let { parentMode } = selectedStatus;
      apiEvent.setAgentState(parentMode, store.getters.callLoginId, selectedStatus.subMode);
      logReport.write(`[CHANGE-AGENT]${selectedStatus.statusType}`);
      this.commit('changeCallAgentStatus', selectedStatus.statusType);
    }
  },
  changeCurrentCallBrand(state, payload) {
    if (payload.brandId) {
      state.callInfo.callBrand = store.getters.getCallBrandList.find((brand) => String(brand.brandId) === String(payload.brandId));
      return;
    }
    if (payload.dnis) {
      state.callInfo.callBrand = store.getters.getCallBrandList.find((brand) => String(brand.calledNumber) === String(payload.dnis));
    }
  },
  initDimmed(state) {
    const isOffline = store.getters.IS_OFFLINE;
    if (isOffline) {
      state.isDimmed = true;
      state.dimmedTitle = '네트워크 연결이 끊어졌습니다.';
      state.dimmedContent = '<span>네트워크 연결이 끊어졌습니다. 네트워크 연결을 확인해주세요.</span>';
      logReport.write('[ERROR] - 네트워크 연결이 끊어졌습니다. 네트워크 연결을 확인해주세요.');
      return;
    }

    if (store.getters.getCallBrandList.length <= 0) {
      // 콜 사용 가능한 브랜드가 없을 경우
      state.dimmedTitle = '사용중인 서비스가 아닙니다.';
      state.dimmedContent = `<span style="display:block">워크플레이스 > 브랜드명 > '채널 연동' 에서 <span class="fw-bold">'콜 연동신청'</span>이 필요합니다.`;
      state.isInitUi = true;
      state.isDimmed = true;
      return;
    }

    const isExistCallAgent = store.getters.isExistCallAgent;
    const enabledCallAgent = store.getters.enabledCallAgent;
    if (!isExistCallAgent || !enabledCallAgent) {
      state.isDimmed = true;
      state.dimmedTitle = '사용중인 서비스가 아닙니다.';
      state.dimmedContent = `<span>워크플레이스 > 콜 내선 번호 관리에서 <span class="fw-bold">‘내선번호’</span>를 저장해 주세요.<span>`;
      return;
    }

    const isKtOrKlcns = store.getters.isKtOrKlcns;
    const IS_OVER_LAP = store.getters.IS_OVER_LAP;
    if (isKtOrKlcns && IS_OVER_LAP) {
      state.isDimmed = true;
      state.dimmedTitle = '페이지 오류가 발생했습니다.';
      state.dimmedContent = '<span>페이지가 중복되었습니다. 새로고침을 해주세요.</span>';
      return;
    }

    if (!store.getters.IS_CALL_CONNECTED) {
      state.isDimmed = true;
      state.dimmedTitle = '일시적인 오류가 발생했습니다.';
      state.dimmedContent = '<span>서버와 연결이 끊어졌습니다. 새로고침 또는 인터넷 연결을 확인해주세요.</span>';
      logReport.write('[ERROR] - 서버와 연결이 끊어졌습니다. 새로고침 또는 다시 로그인 해주세요.');
      return;
    }

    if (!store.getters.IS_VALID_TEL) {
      state.isDimmed = true;
      state.dimmedTitle = '내선번호 확인이 필요합니다.';
      state.dimmedContent = '<span>등록되지 않은 내선번호입니다. 내선번호 재설정 후 로그인 해주세요.</span>';
      return;
    }

    if (!store.getters.IS_TEL_ING) {
      state.isDimmed = true;
      state.dimmedTitle = '내선번호 확인이 필요합니다.';
      state.dimmedContent = '<span>이미 등록된 내선번호입니다. 내선번호 확인 후 새로고침을 해주세요.</span>';
      return;
    }

    if (IS_OVER_LAP) {
      const { isNeoWebRtc } = store.getters;
      state.isDimmed = true;
      state.dimmedTitle = '페이지 오류가 발생했습니다.';
      state.dimmedContent = '<span>새로고침을 해주세요.</span>';
      if (isNeoWebRtc) {
        logReport.write('[ERROR] - INIT_DIMMED - IS_OVER_LAP');
      } else {
        logReport.write('[ERROR] - 페이지가 중복되었습니다. 새로고침을 해주세요.');
      }
      return;
    }

    state.isDimmed = false;
    state.dimmedTitle = '';
    state.dimmedContent = '';
  },
  changeIsDragging(state, payload) {
    state.isDragging = payload;
  },
  changeIsSpying(state, payload) {
    state.isSpying = payload;
  },
  setIsErpSavePossible: (state, payload) => {
    state.callInfo.isErpStoragePassible = !!payload;
  },
  changeUsageLocation: (state, payload) => {
    state.callInfo.usageLocation = payload;
  },
  changeViewingCallbackDateTime(state, payload) {
    state.viewingCallbackDateTime = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/call/callStatus.js